import * as React from 'react'
import {Box} from "@mui/material";
import {formatProductsUnits} from "@ui-seeker/utils";


export default function offersColumn() {
    return {
        name: 'numOffers', label: 'Nº Offers',
        options: {
            customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                {formatProductsUnits(value)}
            </Box>
        }
    }
}